import { FC } from 'react';
import { StanButton, StanLink } from '@/components';
import { cn, createIconElement } from '@/lib';
import { connectInstagram } from '@/lib/utils/instagramConnect';
import type { InstagramStatus } from '../types/automation.types';

import InstagramIcon from '@/assets/icons/integrations/instagram.svg';
import WarningIcon from '@/assets/icons/ic-warning-circle.svg';
import SettingsIcon from '@/assets/icons/ic-settings.svg';
import IcFlows from '@/assets/icons/ic-flows.svg';
import IcPlus from '@/assets/icons/ic-plus.svg';

interface AutomationHeaderProps {
    igUsername?: string;
    instagramStatus: InstagramStatus;
    onAddAutomation: () => void;
}

export const AutomationHeader: FC<AutomationHeaderProps> = ({ igUsername, instagramStatus, onAddAutomation }) => {
    const handleReconnect = () => {
        connectInstagram();
    };

    return (
        <div className='mb-3 flex items-center justify-between'>
            {/* Instagram Username Section */}
            <div className='flex min-w-0 flex-1 items-center overflow-hidden pr-5'>
                {igUsername && (
                    <div className='flex min-w-0 items-center gap-2 px-2 py-5'>
                        {instagramStatus === 'not-connected' ? (
                            <WarningIcon className='fill-negative size-6 flex-shrink-0' />
                        ) : (
                            <InstagramIcon className='size-5 flex-shrink-0' />
                        )}
                        <span
                            className={cn(
                                'text-body-sm mr-2 truncate font-semibold',
                                instagramStatus === 'not-connected' ? 'text-gray' : 'text-dark'
                            )}
                        >
                            @{igUsername}
                        </span>
                        <StanLink
                            to='/account_settings?tab=integrations'
                            className='flex-shrink-0 opacity-50 transition-opacity hover:opacity-100'
                            aria-label='Settings'
                        >
                            <SettingsIcon className='size-5' />
                        </StanLink>
                    </div>
                )}
            </div>

            {/* Action Buttons */}
            {instagramStatus === 'not-connected' ? (
                <StanButton
                    name='reconnect-instagram'
                    variant='outline'
                    color='destructive'
                    size='md'
                    onClick={handleReconnect}
                    icon={IcFlows}
                >
                    <span className='hidden sm:inline'>Reconnect</span>
                    <span className='sm:hidden'>Reconnect</span>
                </StanButton>
            ) : (
                <StanButton
                    name='create-automation'
                    size='sm'
                    onClick={onAddAutomation}
                    icon={createIconElement(IcPlus, { className: 'size-5' })}
                >
                    <span className='hidden sm:inline'>Create Reply</span>
                    <span className='sm:hidden'>Create</span>
                </StanButton>
            )}
        </div>
    );
};
